import { Box, Card, CardBody, Flex } from '@chakra-ui/react';
import { variantsApi } from '@texas/api/endpoints/variantsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { VersionsListViewStandard } from './VersionListViewStandard';
import { SpinnerWithLabel } from '@texas/components/shared/SpinnerWithLabel';
import { VersionsFilters } from '../shared/VersionsFilters';

interface Props {
  variantId: number;
  initialBranchId?: number;
}

export function StandardVersions({ variantId, initialBranchId }: Props) {
  const { t } = useTranslation();
  const {
    data: suppliers,
    refetch: refetchSuppliers,
    loading,
  } = useApiResource(variantsApi.getVariantBranchSuppliers);

  useEffect(() => {
    refetchSuppliers(variantId, false);
  }, [refetchSuppliers, variantId]);

  return (
    <Box>
      <Card variant="dark">
        <CardBody bg="gray.800" _light={{ bg: 'white' }}>
          <Flex gap={4}>
            <VersionsFilters
              variantId={variantId}
              hideBranchFilter={true}
              initialBranchId={initialBranchId}
            />
          </Flex>
        </CardBody>
      </Card>
      {loading && (
        <Box py={2}>
          <SpinnerWithLabel label={t('suppliers.loading')} />
        </Box>
      )}
      {suppliers && (
        <Card variant="dark" mt={4}>
          <CardBody>
            <VersionsListViewStandard
              variantId={variantId}
              suppliers={suppliers.suppliers}
              branches={suppliers.branches}
            />
          </CardBody>
        </Card>
      )}
    </Box>
  );
}
